import { render, staticRenderFns } from "./ObjectImagesPreview.vue?vue&type=template&id=32536fed"
import script from "./ObjectImagesPreview.vue?vue&type=script&lang=js"
export * from "./ObjectImagesPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports